import "./styles.scss"

import React from "react"
import {
  FacebookShareButton,
  TwitterShareButton,
  LinkedinShareButton,
  EmailShareButton,
} from "react-share"
import clsx from "clsx"

const ShareList = ({ className, label, url }) => {
  return (
    <div className={clsx("share-list", className)}>
      {label && <strong>{label}:</strong>}
      <FacebookShareButton url={url}>
        <img src={require("assets/icons/social-facebook.svg").default} alt="" />
      </FacebookShareButton>
      <TwitterShareButton url={url}>
        <img src={require("assets/icons/social-twitter.svg").default} alt="" />
      </TwitterShareButton>
      <LinkedinShareButton url={url}>
        <img src={require("assets/icons/social-linkedin.svg").default} alt="" />
      </LinkedinShareButton>
      <EmailShareButton url={url}>
        <img src={require("assets/icons/social-email.svg").default} alt="" />
      </EmailShareButton>
    </div>
  )
}

export default ShareList
